'use client';

import { loginRedirect } from '@svenskaspelab/nova-core/nextjs/auth';
import { Button } from '@svenskaspelab/ui/react/button';
import type { ReactNode } from 'react';

const handleLoginClick = (): void => {
  loginRedirect();
};

/**
 * Renders a file upload form for logged out users.
 *
 * @returns file upload login form component
 */
export function FileUploadLogin(): ReactNode {
  return (
    <>
      <p className="mt-3 mb-3">Logga in för att ladda upp ditt spel</p>
      <Button type="button" onClick={handleLoginClick}>
        Logga in
      </Button>
    </>
  );
}
